module.exports = __webpack_public_path__ + "img/type(6).0ccc741f.png";